<template>
  <div class="content">
    <h3 ref="pageHeader" class="pageHeader">仪器设备入库记录</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="是否大型设备">
          <el-select v-model="formInline.is_big_device" clearable filterable placeholder="请选择是否大型设备">
            <el-option v-for="item in $store.state.iss" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="入库开始日期">
          <el-date-picker v-model="formInline.start_date" type="date" value-format="yyyy-MM-dd" clearable
            placeholder="选择开始日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="入库结束日期">
          <el-date-picker v-model="formInline.end_date" type="date" value-format="yyyy-MM-dd" clearable
            placeholder="选择结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="供应商">
          <el-input v-model="formInline.supplier" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增入库记录</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table ref="table" :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="device_name" label="设备名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="created_at" label="入库时间" width="160">
        </custom-table-column>
        <custom-table-column prop="device_category_desc" label="设备分类" width="160">
        </custom-table-column>
        <custom-table-column label="是否大型设备" prop="is_big_device" width="150" label-class-name="iss"
          :formatter="format_arr">
        </custom-table-column>
        <custom-table-column prop="structureFull" label="所属组织结构" width="160">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="150">
        </custom-table-column>
        <custom-table-column prop="device_model" label="型号" width="150">
        </custom-table-column>
        <custom-table-column prop="specification" label="规格" width="160">
        </custom-table-column>
        <custom-table-column prop="country_code" label="国别码" width="160">
        </custom-table-column>
        <custom-table-column prop="device_price" label="单价" width="160">
        </custom-table-column>
        <custom-table-column prop="device_qty" label="库存数量" width="160">
        </custom-table-column>
        <custom-table-column prop="purchase_date" label="购置日期" width="160">
        </custom-table-column>
        <custom-table-column prop="supplier" label="供应商" width="160">
        </custom-table-column>
        <custom-table-column prop="attachmentstr" fixed="right" label="合同附件" width="200px">
          <template slot-scope="scope" v-if="scope.row.attachments">
            <el-tag v-for="tag in scope.row.attachments" :key="tag.id"><span style="cursor: pointer;"
                @click="handleClickTag(tag.file_url)">{{ tag.file_name }}</span>
              <el-popconfirm title="确定删除该附件吗？" @confirm="deleteFile($event, tag.id, scope.row.id)">
                <el-button type="info" size="mini" circle slot="reference" icon="el-icon-delete"></el-button>
              </el-popconfirm>
            </el-tag>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <el-button @click="upFile(scope.row.id)" type="text" size="small">上传合同</el-button>
            <el-button @click="detailMethod(scope.row, 'view')" type="text" size="small">查看详情</el-button>
            <el-button @click="detailMethod(scope.row, 'edit')" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            <el-button @click="handlePrintRow(scope.row)" type="text" size="small">打印</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="设备名称" prop="device_name">
          <el-input v-model="ruleForm.device_name" placeholder="请输入" clearable style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="入库数量" prop="device_qty">
          <el-input v-model.number="ruleForm.device_qty" placeholder="请输入" @blur="handleBlurDeviceNum" clearable
            style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="所属组织结构" prop="structure_1">
          <el-input v-model="selectName" placeholder="请选择" style="width:552px;" @focus="dialogOpen"
            @clear="handeleClear" @blur="handleBlurOrgan" clearable></el-input>
        </el-form-item>
        <el-form-item label="学年学期" prop="term">
          <el-select v-model="ruleForm.term" clearable placeholder="请选择学年学期" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备分类" prop="device_category">
          <el-cascader v-model="ruleForm.device_category" ref="cascader" :show-all-levels="false" :props="props"
            style="width:216px;" clearable :options="$store.state.sbflh" @change="handleCascaderChage">
            <template slot-scope="{ node, data }">
              <span>{{ data.name }}</span>
              <span v-if="data.code" style=" color: #8492a6; font-size: 13px"> ({{ data.code }}) </span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item label="是否大型设备" prop="is_big_device">
          <el-select v-model="ruleForm.is_big_device" clearable placeholder="请选择" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.iss" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格" prop="specification">
          <el-input v-model="ruleForm.specification" clearable placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="型号" prop="device_model">
          <el-input v-model="ruleForm.device_model" clearable placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="国别码" prop="country_code">
          <el-select v-model="ruleForm.country_code" clearable placeholder="请选择" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.gbm" :key="index" :label="`${item.name_zh}(${item.code})`"
              :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单价" prop="device_price">
          <el-input v-model="ruleForm.device_price" clearable placeholder="请输入" style="width:198px;"></el-input> 元
        </el-form-item>
        <el-form-item label="仪器来源" prop="source">
          <el-select v-model="ruleForm.source" clearable placeholder="请选择仪器来源" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.eqSource" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="购置日期" prop="purchase_date">
          <el-date-picker type="date" placeholder="请选择到校验收日期" clearable value-format="yyyy-MM-dd"
            v-model="ruleForm.purchase_date" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="供应商" v-if="ruleForm.source == 1" prop="supplier"
          :rules="[{ required: true, message: '请输入', trigger: 'blur' }]">
          <el-input v-model="ruleForm.supplier" clearable placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="供应商" v-else prop="supplier">
          <el-input v-model="ruleForm.supplier" clearable placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <div class="add_win ">
          <p class="add_win_title">入库清单</p>
          <div v-for="(item, index) in ruleForm.individuals" :key="index" class="add_win_body el-form">
            <el-form-item label="资产编号" :prop="`individuals[${index}].serial_no`">
              <el-input v-model="item.serial_no" placeholder="请输入" style="width:196px;"></el-input>
            </el-form-item>
            <el-form-item :label="`${$store.state.themeTitle}室`" :prop="`individuals[${index}].training_room_id`">
              <el-select v-model="item.training_room_id" style="width:196px;" fliterable :placeholder="`请先选择组织结构`">
                <el-option v-for="itemm in $store.state.trainRooms" :key="itemm.id" :label="itemm.training_name"
                  :value="itemm.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级学院编号" :prop="`individuals[${index}].second_college_number`">
              <el-input v-model="item.second_college_number" placeholder="请输入" style="width:196px;"></el-input>
            </el-form-item>
            <!-- <div style="margin-top:12px;text-align:center;">
              <el-button type="danger" @click="handleItemDelete(item, index)" size="mini">删除</el-button>
            </div> -->
          </div>
          <!-- <div style="margin-top:12px;text-align:center;">
            <el-button size="mini" @click="handleItemAdd()">新增一条+</el-button>
          </div> -->
        </div>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="入库详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="" direction="vertical" :column="3" border>
        <el-descriptions-item>
          <template slot="label">设备名称 </template> {{ rowObj.device_name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">设备分类 </template> {{ rowObj.device_category_desc }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">是否大型设备</template> {{ rowObj.is_big_device == 1 ? '是' : '否' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">所属组织结构 </template> {{ rowObj.structure_1 }}{{ rowObj.structure_2 }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">学年学期 </template> {{ rowObj.term }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">型号 </template> {{ rowObj.device_model }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">规格 </template> {{ rowObj.specification }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">国别码 </template> {{ rowObj.country_code }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">单价 </template> {{ rowObj.device_price }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">库存数量 </template> {{ rowObj.device_qty }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">购置日期 </template> {{ rowObj.purchase_date }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">供应商 </template> {{ rowObj.supplier }}
        </el-descriptions-item>
        <!-- <el-descriptions-item>
          <template slot="label">合同协议 </template> {{ rowObj.supplier }}
        </el-descriptions-item> -->
      </el-descriptions>
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;">入库清单</p>
      <el-descriptions class="margin-top" title="" style="margin-bottom:16px;"
        v-for="(item, index) in rowObj.individuals" :key="index" direction="vertical" :column="2" border>
        <el-descriptions-item>
          <template slot="label">资产编号 </template> {{ item.serial_no }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">所属{{ $store.state.themeTitle }}室</template> {{
            item.training_room ? item.training_room.training_name : '无' }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="上传合同附件" :visible.sync="fileUpDialogVisible" width="546px">
      <el-form :model="ruleFormFile" :rules="rulesFile" ref="ruleFormFile" label-width="120px" class="demo-ruleForm">
        <el-form-item label="附件" prop="file_path" style="width:100%">
          <Uploadd ref="uploadd" fileFormNameIn="ruleFormFile" fileFieldNameIn="file_path" :isMultiple="true"
            btnTitle="点击上传文件" @setFileList="setFileListMultiple" @delFile="delUpFile"></Uploadd>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleFormFile', upFileMethod)">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <div style="display: none;">
      <Printt id="printArea" ref="printt" :printData="printData" printTitle="设备入库"></Printt>
    </div>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinUpload } from '@/assets/js/mixin/upload';
import { mixinPrint } from '@/assets/js/mixin/print';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinValidate, mixinFormatter, mixinUpload, mixinPrint],
  data() {
    return {
      formInline: {

      },
      props: {
        value: 'code',
        label: 'name',
        children: 'subcategories',
        emitPath: false
      },
      size: 'small',
      detailDialogVisible: false,
      fileUpDialogVisible: false,
      levell: [1],
      selectName: '',
      organLabel: '',
      ruleForm: {
        "device_name": "",
        "device_qty": 1,
        "device_price": 0,
        "device_category": "",
        device_category_desc: '',
        "is_big_device": "",
        "specification": "",
        "country_code": "",
        "structure_1": "",
        "structure_2": "",
        "supplier": "",
        "source": "",
        "purchase_date": "",
        "individuals": [{ "serial_no": "", "training_room_id": "", "second_college_number": "" }]
      },
      ruleFormFile: {
        id: '',
        file_path: '',
      },
      rowObj: {},
      plist: [],
      classRooms: [],
      rules: {
      },
      rulesFile: {
        file_path: [{ required: true, message: '请上传' }],
      },
      rulesRoot: {
        device_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        device_qty: [
          { required: true, message: '请输入', trigger: 'blur' },
          { type: 'number', message: '必须为数字值', trigger: 'blur' },
        ],
        device_price: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        term: [{ required: true, message: '请选择', trigger: 'change' }],
        device_category: [{ required: true, message: '请选择', trigger: 'change' }],
        specification: [{ required: true, message: '请输入', trigger: 'blur' }],
        device_model: [{ required: true, message: '请输入', trigger: 'blur' }],
        country_code: [{ required: true, message: '请选择', trigger: 'change' }],
        source: [{ required: true, message: '请选择', trigger: 'change' }],
        is_big_device: [{ required: true, message: '请选择', trigger: 'change' }],

        purchase_date: [{ required: true, message: '请选择', trigger: 'change' }],
        structure_1: [{ required: true, message: '请选择' }],
        // training_room: [{ required: true, message: `请输入所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
        type: [{ required: true, message: '请输入入库类别', trigger: 'blur' }],
      },
      action: '',
      downloadUrl: 'template/设备导入模版.xlsx',
      btnTitle: '导入入库数据',
      listArr: [],
      subcategories: []
    };
  },
  async created() {
    this.action = `${this.baseUrlt}api/new_device/storage/import`;
    this.$store.dispatch('getGbm');
    this.$store.dispatch('getTermms');
    await this.$store.dispatch('getSbflh')
    this.$store.state.sbflh.forEach(item => {
      this.subcategories = this.subcategories.concat(item.subcategories)
    })
    // this.$store.dispatch('getTermms');
  },
  computed: {
    total_price() {
      // this.total_price = this.quantity*this.price
      return (this.ruleForm.quantity * this.ruleForm.price * 1000) / 1000;
    },
  },
  mounted() {
    this.rules = {
      ...this.rulesRoot,
      ...this.generateArrRules()
    };
  },
  methods: {
    handleClickTag(url) {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
    },
    upFile(id) {
      if (this.$refs.uploadd) {
        this.$refs.uploadd.setRefFileList('');
      }
      this.fileUpDialogVisible = true
      this.ruleFormFile.id = id
    },
    async deleteFile(e, attachmentId, id) {
      let res = await this.$api.instance.interfaceServer(`api/new_device/storage/attachment/${id}/${attachmentId}`, 'DELETE');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.handleQuery();
      }
    },
    async upFileMethod() {
      let res = await this.$api.instance.interfaceServer(`api/new_device/storage/attachment/${this.ruleFormFile.id}`, 'post', this.ruleFormFile);
      if (res.code == 0) {
        this.$message.success('上传成功！')
        this.fileUpDialogVisible = false
        this.handleQuery()
      }
    },
    generateArrRules() {
      const arrRules = {};
      this.ruleForm.individuals.forEach((item, index) => {
        arrRules[`individuals[${index}].serial_no`] = [
          { required: true, message: `请输入`, trigger: 'blur' }
        ];
        arrRules[`individuals[${index}].second_college_number`] = [
          { required: true, message: `请输入`, trigger: 'blur' }
        ];
        arrRules[`individuals[${index}].training_room_id`] = [
          { required: true, message: `请选择`, trigger: 'change' }
        ];
      });
      return arrRules;
    },
    handleBlurOrgan() {
      console.log(this.ruleForm.structure_1)
    },
    handleItemDelete(item, index) {
      this.ruleForm.individuals.splice(index, 1);
    },
    handleBlurDeviceNum() {
      const forEachNum = this.ruleForm.device_qty - this.ruleForm.individuals.length
      if (forEachNum > 0) {
        for (let i = 0; i < forEachNum; i++) {
          this.ruleForm.individuals.push({ "serial_no": "", "training_room_id": "0", "second_college_number": "" })
        }
      } else if (forEachNum < 0) {
        this.ruleForm.individuals.splice(this.ruleForm.individuals.length + forEachNum, Math.abs(forEachNum))
      }
      this.rules = {
        ...this.rulesRoot,
        ...this.generateArrRules()
      };
    },
    handleAdd() {
      this.type = 'add';
      this.title = '新增';
      if (this.selectName) {
        this.selectName = '';
      }
      this.$store.commit('setTrainRooms', [{ id: '0', training_name: '无' }]);
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    handleEdit(row, filterArr = ['create_at', 'school_id']) {
      this.type = 'edit';
      this.title = '编辑';
      if (row.structure_1) {
        this.selectName = `${row.structure_1}${row.structure_2 ? `-${row.structure_2}` : ''}`;
      }
      this.ruleForm = this.$until.delProp(row, filterArr);
      this.handleBlurDeviceNum()
      this.editInit()
      this.centerDialogVisible = true;
    },
    editInit() {
      this.$store.dispatch('getTarinMent', { structure_1: this.ruleForm.structure_1, isEmpty: true });
    },
    handleCascaderChage(val) {
      this.ruleForm.device_category_desc = this.$until.getLabelName(this.subcategories, 'code', 'name', val);
    },
    async detailMethod(row, type = "view") {
      let res = await this.$api.instance.interfaceServer(`api/new_device/storage/detail/${row.id}`, 'get');
      if (res.code == 0 && res.data) {
        if (type == "edit") {
          let params = this.$until.delProp(res.data, ['individuals'])
          params.individuals = res.data.individuals.map(item => {
            return {
              training_room_id: item.training_room_id?item.training_room_id:'0',
              serial_no: item.serial_no,
              second_college_number: item.second_college_number,
            }
          })
          this.handleEdit(params)
        } else {
          this.rowObj = res.data;
          this.detailDialogVisible = true;

        }
      }
    },
    handleInput(item) {
      item.zj = item.dj * item.sl;
      // return  item.zj
    },
    handleItemAdd() {
      this.ruleForm.individuals.push({ serial_no: '', training_room_id: '', second_college_number: '' });
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/new_device/storage/delete/${this.delid}`, 'DELETE');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/new_device/storage/store', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/new_device/storage/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.beforeGetOrgan({ limit: false, major: "structure_2" });
      this.editInit()
    },
    handleQuery() {
      this.beforeQueryByKeyNew({ major: "structure_2" })
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/new_device/storage/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data.map(item => ({
          ...item,
          structureFull: item.structure_1 + item.structure_2,
          attachmentstr:item.attachments.map(item=>item.file_url).join(',')
        }));
        this.total = res.data.total;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

/deep/.el-tag {
  white-space: wrap;
  height: auto;

  .el-button--mini.is-circle {
    padding: 4px;
  }

  // button{
  //   background: #ccc;
  //   border-radius: 50%;
  //   padding:4px;
  // }
}
</style>
